import { weekdays } from 'moment'
import { enumHLSearchDataType } from '../../VisualunitHelpers'
import { IHLDataType,IHLreturnData, ISetObjectForHLDate } from '../VuParamsHelpers'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'

export type TBpObject = {[key: string]: IBusinessParamsOptions} | null | undefined
export const ConvertFilterDisplayText = (replacstr: string, inputs: any, isBusinessParameter: 0 | 1, bpObject : TBpObject = null) => {
    const HldateRelativerangdisplayText =
        'from today, minus replacetext2 replacetext3, and plus replacetext4 replacetext5' //Fixed
    const HldateRelativerangconvertedDisplayTextValue =
        '[today] [replacetext2] [replacetext3] [replacetext4] [replacetext5]'
    const HldateNewRelativerangdisplayText = 'from value1 upTo value2 value3 before Today'
    const HldateNewRelativerangconvertedDisplayTextValue = '[value1] [today] [value2] [value3]'
    const arrayHLDateMonths = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ]
    const arrayHLDateWeekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const regexPattern = new RegExp(`\\[(${Object.keys(enumHLSearchDataType).join('|')})\\]`, 'gi')

    // Function to check if any enum key in brackets is present in the string and return the enum values
    function findEnumsInString(inputString: string) {
        const matches = inputString.match(regexPattern)
        if (matches) {
            // Remove the square brackets and return only the enum value (without brackets)
            return matches.map((match) => match.slice(1, -1))
        }
        return [] // Return an empty array if no matches are found
    }
    let displayText = replacstr
    let displayTextValue = replacstr
    if (
        !displayText.includes(enumHLSearchDataType.HLDate_Years) &&
        !displayText.includes(enumHLSearchDataType.HLDate_Weekdays) &&
        !displayText.includes(enumHLSearchDataType.HLDate_Multiple_Dates) &&
        !displayText.includes(enumHLSearchDataType.HLDate_Relative_Range) &&
        !displayText.includes(enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE)
    ) {
        const searchDataType = findEnumsInString(displayText)
        //if displayText= "is from [HLNUMBER_FROM] to [HLNUMBER_TO]" => Transform to=> ["is from ", "[HLNUMBER_FROM]", " to ", "[HLNUMBER_TO]"]
        //if displayText = "[HLNUMBER_FROM] [HLNUMBER_TO]" Transform to => ["HLNUMBER_FROM", "HLNUMBER_TO"]

        const splitWithHLType = displayText.split(/(\[[^\]]+\]|[^\[\]]+)/).filter(item => item.trim() !== "");

        let availableBusinessParams = ["hlduration", "hlnumber", "hlcount", "hlmoney"]

        if(isBusinessParameter === 1 && bpObject){ //bpObject may come undefined or null, so checking for falsy values
            if(splitWithHLType.length > 0){
                splitWithHLType.forEach((itr: string, part_index: number)=>{
                    let dataType = itr.includes("[") ? itr.replace(/\[|\]/g, "") : "";
                    if(dataType){  //is a data type not plain text like like 'is from', 'is greater that'.. etc
                        let dataTypeFound = availableBusinessParams.some(param => dataType.toLowerCase().includes(param));
                        if(dataTypeFound && bpObject.hasOwnProperty(part_index)){ ////Some times dataTypes may comes as BusinessParams but its a other data types identified as Object.keys(bpObject).includes(index.toString()
                            let currentBpObject = bpObject[part_index]
                            let bpDisplayText = `${currentBpObject.BPValue} (${currentBpObject.Name})`;
                            let bpDisplayTextValue = `[{${currentBpObject.Id}}]`
                            displayText = displayText.replace(itr, bpDisplayText) //dispText = is greater than [HLDURATION_NUMBER] [HLDURATION_PERIOD], inputs[dataType] = duration/ number 
                            displayTextValue = displayTextValue.replace(itr, bpDisplayTextValue)
                        }else{ //its a normal data type whic is not a business parameter data type.
                            displayText = displayText.replace(itr, inputs[dataType])
                            displayTextValue = displayTextValue.replace(itr, inputs[dataType])
                        }
                    }else{
                        displayText = displayText.replace(itr, itr)
                        displayTextValue = displayTextValue.replace(itr, itr)
                    }
                })
            }
        }else{
            searchDataType?.map((dataType) => {
                displayText = displayText.replace('[' + dataType + ']', inputs[dataType])
                displayTextValue = displayTextValue.replace(dataType, inputs[dataType])
            })
        }
        return { displayText, displayTextValue }
    } else {
        if (displayText.includes(enumHLSearchDataType.HLDate_Multiple_Dates)) {
            const dates = inputs[enumHLSearchDataType.HLDate_Multiple_Dates]

            displayText = `Dates: [${dates.join(', ')}]`
            displayTextValue = '[' + dates.map((date: any) => `'${date}'`).join(', ') + ']'

            return { displayText, displayTextValue }
        } else if (displayText.includes(enumHLSearchDataType.HLDate_Years)) {
            const Years = inputs[enumHLSearchDataType.HLDate_Years]
            const Months = inputs[enumHLSearchDataType.HLDate_Months]

            const formattedYears = `Years: [${Years.join(', ')}]`
            const formattedMonths = `Months: [${Months?.map((index: number) => arrayHLDateMonths[index]).join(', ')}]`
            displayText = displayText.replace(
                `[${enumHLSearchDataType.HLDate_Years}]`,
                Years?.length > 0 ?
                formattedYears : ""
            )
            displayText = displayText.replace(
                `[${enumHLSearchDataType.HLDate_Months}]`,
                Months?.length > 0 ?
                formattedMonths : ""
            )

            displayTextValue = [
                Years.length > 0 ? `[${Years.join(', ')}]` : '[]',
                Months.length > 0 ? `[${Months.join(', ')}]` : '[]'
            ].filter(Boolean).join(' ');
            
            return { displayText, displayTextValue }
        } else if (displayText.includes(enumHLSearchDataType.HLDate_Weekdays)) {
            const Weekdays = inputs[enumHLSearchDataType.HLDate_Weekdays]
            const formattedWeekdays = `Weekdays: [${Weekdays.map((index: number) => arrayHLDateWeekdays[index]).join(', ')}]`
            displayText = displayText.replace(
                `[${enumHLSearchDataType.HLDate_Weekdays}]`,
                formattedWeekdays
            )
            displayTextValue = `[${Weekdays.join(', ')}]`
            return { displayText, displayTextValue }
        } else if (displayText.includes(enumHLSearchDataType.HLDate_Relative_Range)) {
            let value2 = inputs[`${enumHLSearchDataType.HLDate_Relative_Range}_2`]
            let value3 = inputs[`${enumHLSearchDataType.HLDate_Relative_Range}_3`]
            let value4 = inputs[`${enumHLSearchDataType.HLDate_Relative_Range}_4`]
            var value5 = inputs[`${enumHLSearchDataType.HLDate_Relative_Range}_5`]
            if (value2 == '') value2 = '0'
            if (value4 == '') value4 = '0'

            displayTextValue = HldateRelativerangconvertedDisplayTextValue
            displayText = HldateRelativerangdisplayText
            displayText = displayText.replace('replacetext2', value2)
            displayTextValue = displayTextValue = displayTextValue.replace('replacetext2', value2)
            displayText = displayText.replace('replacetext3', value3)
            displayTextValue = displayTextValue.replace('replacetext3', value3)
            displayText = displayText.replace('replacetext4', value4)
            displayTextValue = displayTextValue.replace('replacetext4', value4)
            displayText = displayText.replace('replacetext5', value5)
            displayTextValue = displayTextValue.replace('replacetext5', value5)

            return { displayText, displayTextValue }
        } else if (displayText.includes(enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE)) {
            let value1 = inputs[`${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_1`]
            let value2 = inputs[`${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_2`]
            let value3 = inputs[`${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_3`]
            // var value5 = inputs[`${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_5`];

            if (value2 == "") value2 = "0";
            // if (value4 == "") value4 = "0";

            displayTextValue = HldateNewRelativerangconvertedDisplayTextValue //'[value1] [today] [value2] [value3]'
            displayText = HldateNewRelativerangdisplayText
            displayText = displayText.replace('value1', value1 || "")
            displayText = displayText.replace('value2', value2 || '0')
            displayText = displayText.replace('value3', value3|| "hours")

            displayTextValue = displayTextValue.replace('value1', value1)
            displayTextValue = displayTextValue.replace('value2', value2)
            displayTextValue = displayTextValue.replace('value3', value3)

            return { displayText, displayTextValue }
        }else{
            console.error('Out Of ConvertFilterDisplayText..')
        }
    }
}

function getYearsAndMonths(filterValue: string, filterableValueDisplay: string) {
    let Years: number[] = [];
    let Months: any[] = [];
    let Weekdays: any[] = [];

    // Extract years from filterableValueDisplay
    if (filterableValueDisplay.toLowerCase().includes('years')) {
        const yearsMatch = filterValue.match(/\[([^\]]*)\]/);  // Regex to match numbers inside []
        if (yearsMatch) {
            Years = yearsMatch[1].split(',').map(year => parseInt(year.trim()));  // Convert to array of integers
        }
    }

    if (filterableValueDisplay.includes('Months')) {
        const monthsMatch = filterValue.match(/\[([^\]]*)\]/g);  // Regex to match multiple arrays inside []
        if (monthsMatch && monthsMatch.length > 0) {
            let matchIndex = Years.length ? 1 : 0 //If years are added then we are getting months array in 2nd position.. or its on 1st posn
            const monthsIndexArray = monthsMatch[matchIndex].slice(1, -1);  // Extract the second array (months indices)
            Months = monthsIndexArray.split(',').map(monthIndex => parseInt(monthIndex.trim()));  // Get indices (as numbers)
        }
    }
    if (filterableValueDisplay.includes('Weekdays')) {
        const weekdaysMatch = filterValue.match(/\[([^\]]*)\]/g);  // Regex to match multiple arrays inside []
        if (weekdaysMatch && weekdaysMatch.length > 0) {
            const weekdaysIndexArray = weekdaysMatch[0].slice(1, -1);  // Extract the second array (week indices)
            Weekdays = weekdaysIndexArray.split(',').map(weekIndex => parseInt(weekIndex.trim()));  // Get indices (as numbers)
        }
    }

    return { Years, Months, Weekdays };
}

export const parseConvertedFilterDispText = (replacstr: string, filterableValueDisplay: string, filterValue: string) => { //this function is exact opposite of above function.. ConvertFilterDisplayText
    let returnedObject: IHLreturnData = {
        HLDATE_FROM: null,
        HLDATE_TO: null,
        HLTIME_FROM: "12:00 am",
        HLTIME_TO: "11:59 pm",
        HLDATE_PERIOD1: "today",
        HLDATE_YEARS: [],
        HLDATE_MONTHS: [],
        HLNUMBER: null,
        HLDATETIME_PERIOD: "hours",
        HLNUMBER_FROM: '',
        HLNUMBER_TO: '',
        HLDURATION_NUMBER: '2',
        HLDURATION_PERIOD: 'hours',
        HLDURATION_NUMBER_FROM: '2',
        HLDURATION_NUMBER_TO: '7',
        HLDURATION_PERIOD_FROM: 'hours',
        HLDURATION_PERIOD_TO: 'hours',
        HLDATE_RELATIVE_RANGE_3: 'hours',
        HLDATE_RELATIVE_RANGE_5: 'hours',
        HLDATE_PERIOD2: "week",
        HLDATE_PERIOD3: "month",
        HLDATE_YEAR: "1"
    }

    const regexPattern = new RegExp(`\\[(${Object.keys(enumHLSearchDataType).join('|')})\\]`, 'gi')
    let displayText = replacstr // its like "[HLDATE_YEARS] [HLDATE_MONTHS]"
    function findEnumsInString(inputString: string) {
        const matches = inputString.match(regexPattern)
        if (matches) {
            // Remove the square brackets and return only the enum value (without brackets)
            return matches.map((match) => match.slice(1, -1)) as IHLDataType[]
        }
        return [] // Return an empty array if no matches are found
    }
    if (
        !displayText.includes(enumHLSearchDataType.HLDate_Years) &&
        !displayText.includes(enumHLSearchDataType.HLDate_Weekdays) &&
        !displayText.includes(enumHLSearchDataType.HLDate_Multiple_Dates) &&
        !displayText.includes(enumHLSearchDataType.HLDate_Relative_Range) &&
        !displayText.includes(enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE)
    ) {
        const regexToMatchHLDataTypes = /\[(.*?)\]/g;
        const HLTypeValues = filterValue.match(regexToMatchHLDataTypes)?.map((match) =>
            match.slice(1, -1)
        )
        if (!HLTypeValues) return

        const searchDataType: IHLDataType[] = findEnumsInString(displayText)
        
        searchDataType?.map((dataType: IHLDataType, index: number) => {
            returnedObject[dataType] = HLTypeValues[index]
        })

        return { ...returnedObject } //TODO:
    } else {
        if (displayText.includes(enumHLSearchDataType.HLDate_Multiple_Dates)) {

            let formatFilterDateValues = filterValue.replace(/'/g, '"'); //e.g. "['03/18/2025', '03/29/2025']" => "["03/18/2025", "03/29/2025"]" (compatible for JSON.parse FP-11362)
            let parsedFilterDates = JSON.parse(formatFilterDateValues)
            // setObject.setMultipleDates(parsedFilterDates)
            let keyMultipleDates = enumHLSearchDataType.HLDate_Multiple_Dates
            returnedObject = {
                ...returnedObject,
                [keyMultipleDates]: parsedFilterDates
            }
            return { ...returnedObject }
        } else if (displayText.includes(enumHLSearchDataType.HLDate_Years)) {
            let yearsKey = enumHLSearchDataType.HLDate_Years
            let monthsKey = enumHLSearchDataType.HLDate_Months
            const {Years, Months} = getYearsAndMonths(filterValue, filterableValueDisplay)
            returnedObject = {
                ...returnedObject,
                [yearsKey]: Years || [],
                [monthsKey]: Months || []
            }
            // setObject.setHLYears(Years ?? [])
            // setObject.setHLMonths(Months ?? [])
            return { ...returnedObject }

        } else if (displayText.includes(enumHLSearchDataType.HLDate_Weekdays)) {
            const {Weekdays} = getYearsAndMonths(filterValue, filterableValueDisplay)
            let keyWeekdays= enumHLSearchDataType.HLDate_Weekdays

            returnedObject = {
                ...returnedObject,
                [keyWeekdays]: Weekdays,
            }

            // setObject.setHLWeekdays(Weekdays)

            return { ...returnedObject }
        } else if (displayText.includes(enumHLSearchDataType.HLDate_Relative_Range)) {
            const regex = /\[([^\]]+)\]/g; //this regex separates out the arrays in string, for e.g. "[today] [12] [quarters] [13] [years]" //we are excluding today FP-11362
            let match;
            const HLRangeArray = [];
            while ((match = regex.exec(filterValue)) !== null) {
                if (match[1] !== "today") {
                    HLRangeArray.push(match[1]);
                }
            }
            let relativeRange2 = `${enumHLSearchDataType.HLDate_Relative_Range}_2`
            let relativeRange3 = `${enumHLSearchDataType.HLDate_Relative_Range}_3`
            let relativeRange4 = `${enumHLSearchDataType.HLDate_Relative_Range}_4`
            let relativeRange5 = `${enumHLSearchDataType.HLDate_Relative_Range}_5`
            const [minus, minusPeriod, plus, plusPeriod] = HLRangeArray

            returnedObject = {
                ...returnedObject,
                [relativeRange2]: minus,
                [relativeRange3]: minusPeriod,
                [relativeRange4]: plus,
                [relativeRange5]: plusPeriod,
            }
            return { ...returnedObject }
        } else if (displayText.includes(enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE)) {
            const rex = new RegExp("\\[(.*)\\] \\[(.*)\\] \\[(.*)\\] \\[(.*)\\]"); //FP-11937- this regex is the correct approach to get this value, Ref-> visualunit.js
            let matches: RegExpExecArray | null = rex.exec(filterValue);

            let relativeRange1 = `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_1`
            let relativeRange2 = `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_2`
            let relativeRange3 = `${enumHLSearchDataType.HLDATE_New_RELATIVE_RANGE}_3`
            if (matches !== null) {
                //FP-11937
                const [ex, date, ex1, number, period, ex2] = [...matches] //ex.. are excluded values, not used
                //valid values are at index , matches[1], matches[3] matches[4] (Release branch logic used)
                returnedObject = {
                    ...returnedObject,
                    [relativeRange1]: date,
                    [relativeRange2]: number,
                    [relativeRange3]: period,
                }
            }
            return { ...returnedObject }
        }else{
            console.error('Out Of parseConvertedFilterDispText..')
        }
    }

    return {}
}